import { SettingOutlined } from "@ant-design/icons";
import React, { useState, useEffect } from "react";
import { Dashboard } from "../../../../components/ExportImgFigma";
import "../../styles.scss";
import MegaTable from "../../../../components/MagaTableV2";
import { mixGetV2 } from '../../../../services/mixin'
import { useSelector } from 'react-redux';
import { selectorInfoUser } from '../../../../store/slices/infoUserSlice';

const ContactHistory = ({ stData = {} as any, stChange = (data: any, type: any) => { } }) => {
  const user = useSelector(selectorInfoUser);
  const newData = () => {
    return stData.xequantam_show && stData.xequantam ? stData.xequantam.filter((item: any) => item.vehicle_name === stData.xequantam_show.vehicle_name) : []
  }
  const STATUS_FIELDS = [
    'vehicle_status', 'group_status_name', 'latest_group_status_name',
    'status_name', 'interaction_vehicle_status', 'interaction_group_status_name',
  ];
  const STATUS_HEADER_KEYWORDS = ['Trạng thái KH', 'Nhận định KH'];

  const getStatusBadgeClass = (value: string) => {
    if (!value) return '';
    const v = value.toLowerCase().trim();
    if (v === 'contact') return 'status-contact';
    if (v === 'cool' || v === 'prospect') return 'status-cool';
    if (v === 'traffic' || v === 'warm' || v === 'appointment' || v === 'test drive') return 'status-traffic';
    if (v === 'hot' || v === 'sale offer') return 'status-hot';
    if (v === 'booking' || v === 'sale contract') return 'status-booking';
    if (v === 'fail' || v === 'fail contract') return 'status-fail';
    return 'status-default';
  };

  const tableColumns = (sourceColumnWarehouse: any) => {
    const temp = [] as any
    sourceColumnWarehouse.vehicle_interest_history?.list.map((col: any) => {
      const isStatus =
        STATUS_FIELDS.includes(col.field) ||
        STATUS_HEADER_KEYWORDS.some((kw: string) => col.headerName?.includes(kw));
      temp.push({
        headerName: col.headerName,
        field: col.field,
        tooltipField: col.field,
        ...(isStatus && {
          cellRenderer: (params: any) => {
            const val = params.value;
            if (!val || val === 'Không xác định') return <span style={{ color: '#181d1f' }}>Không xác định</span>;
            return (
              <div style={{ display: 'flex', alignItems: 'center', height: '100%' }}>
                <span className={`status-badge ${getStatusBadgeClass(val)}`}>{val}</span>
              </div>
            );
          },
        }),
      })
    })
    return temp
  }
  const [megaTableData, setMegaTableData] = useState<any>({
    name: 'TbCacheContactHistory',
    col: [
      ...tableColumns(stData.sourceColumnWarehouse),
      // { field: "interaction_date", headerName: "Ngày tiếp xúc" },
      // { field: "vehicle_status", headerName: "Trạng thái KH" },
      // { field: "group_status_name", headerName: "Nhận định KH" },
      // { field: "branch_name", headerName: "Đơn vị " },
      // { field: "route_name", headerName: "Xưởng dịch vụ" },
      // { field: "customer_interactions_employee_name", headerName: "Nhân viên" },
      // { field: "customer_interactions_employee_code", headerName: "Mã nhân viên" },
      // { field: "details", headerName: "Nội dung tiếp xúc" },
    ],
    listData: [],
    hideRowsSelect: true,
    showSetting: false,
    loading: false,
    height: '400px',
  });

  const JOURNEY_STEPS = ['Contact', 'Cool', 'Prospect', 'Traffic', 'Warm', 'Appointment', 'Test Drive', 'Hot', 'Sale Offer', 'Booking', 'Sale Contract', 'Fail', 'Fail Contract'];

  const getStatusColor = (value: string) => {
    if (!value) return '#D0D5DD';
    const v = value.toLowerCase().trim();
    if (v === 'contact') return '#FA8C16';
    if (v === 'cool' || v === 'prospect') return '#1890FF';
    if (v === 'traffic' || v === 'warm' || v === 'appointment' || v === 'test drive') return '#FAAD14';
    if (v === 'hot' || v === 'sale offer') return '#F5222D';
    if (v === 'booking' || v === 'sale contract') return '#52C41A';
    if (v === 'fail' || v === 'fail contract') return '#475467';
    return '#595959';
  };

  const getJourneySteps = () => {
    if (!detailData.list || detailData.list.length === 0) return [];
    const seen = new Set<string>();
    const steps: string[] = [];
    // Reverse to show from oldest to newest
    const reversed = [...detailData.list].reverse();
    reversed.forEach((item: any) => {
      const status = item.group_status_name;
      if (status && !seen.has(status.toLowerCase().trim())) {
        seen.add(status.toLowerCase().trim());
        steps.push(status);
      }
    });
    return steps;
  };

  const [loading, setLoading] = useState(false);
  const [detailData, setDetailData] = useState<any>({ list: [], latest_interaction_date: '', total_interactions: 0, latest_group_status_name: '' });
  const getDetail = async (id: any) => {
    setLoading(true);
    const res = await mixGetV2(`/api/v1/be/customer/customers_interest_vehicle_history?id_sync=${stData.cus_id}&dms_doc_id=${id}&admin_id=${user.id}&id_veh_info=${stData.xequantam_show.customer_interactions_id_veh_info}`);
    if (res.data) {
      const interactions = res.data.interactions || [];
      const latestGroupStatus = interactions.length > 0 ? (interactions[0].vehicle_status || '') : '';
      setDetailData({
        list: interactions,
        latest_interaction_date: res.data.latest_interaction_date,
        total_interactions: res.data.total_interactions,
        latest_group_status_name: latestGroupStatus
      });
      stChange({
        list: interactions,
        latest_interaction_date: res.data.latest_interaction_date,
        total_interactions: res.data.total_interactions,
        latest_group_status_name: latestGroupStatus
      }, 'customers_interest_vehicle_history');
      setLoading(false);
    }
  }
  useEffect(() => {
    if (stData.xequantam_show && stData.xequantam_show.dms_doc_id) {
      getDetail(stData.xequantam_show.dms_doc_id);
    }
  }, [stData.xequantam_show]);

  return (
    <>
      <div className="setting-tb-has-tab">
        <div className='settingCol'>
          <div className='ctr-col-setting' onClick={() => setMegaTableData((prev: any) => ({ ...prev, showSetting: true }))}>
            <SettingOutlined />
          </div>
        </div>
      </div>
      <div className="custom-page-css w-full flex gap-3 mb-3">
        <div className="custom-page-css flex flex-1 flex-column rounded border" style={{ flex: '1 1 50%', minWidth: 0 }}>
          <div className="custom-page-css w-full flex items-center gap-4 p-3 border-b">
            <div className="custom-page-css flex items-center justify-center p-1 bg-E6F7FF rounded-full w-1/3">
              <img
                src={Dashboard}
                alt=""
                style={{ height: 16, width: 16, objectFit: "contain" }}
              />
            </div>
            <span className="custom-page-css text-xl font-light text-475467">
              Tổng quan
            </span>
          </div>
          <div className="custom-page-css flex py-2">
            <div className="custom-page-css py-2 flex flex-1 flex-column items-center justify-center gap-1 border-r">
              <span className="custom-page-css text-2xl font-light font-medium px-1 text-344054">
                {detailData.total_interactions}
              </span>
              <span className="custom-page-css text-xl font-light text-475467">
                Số lần tiếp xúc
              </span>
            </div>
            <div className="custom-page-css py-2 flex flex-1 flex-column items-center justify-center gap-1 border-r">
              <span className="custom-page-css text-2xl font-light font-medium px-1 text-344054">
                {detailData.latest_interaction_date || "Không xác định"}
              </span>
              <span className="custom-page-css text-xl font-light text-475467">
                Ngày tiếp xúc gần nhất
              </span>
            </div>
            <div className="custom-page-css py-2 flex flex-1 flex-column items-center justify-center gap-1">
              {detailData.latest_group_status_name ? (
                <span className={`status-badge ${getStatusBadgeClass(detailData.latest_group_status_name)}`}>
                  {detailData.latest_group_status_name}
                </span>
              ) : (
                <span className="custom-page-css text-2xl font-light font-medium px-1 text-344054">
                  Không xác định
                </span>
              )}
              <span className="custom-page-css text-xl font-light text-475467">
                Trạng thái KH gần nhất
              </span>
            </div>
          </div>
        </div>
        <div className="custom-page-css flex flex-1 flex-column rounded border d-none" style={{ flex: '1 1 50%', minWidth: 0 }}>
          <div className="custom-page-css w-full flex items-center gap-4 p-3 border-b">
            <span className="custom-page-css text-xl font-light text-475467">
              Hành trình khách hàng
            </span>
          </div>
          <div className="custom-page-css flex items-center justify-center py-3 px-4" style={{ flex: 1 }}>
            <div className="customer-journey-steps">
              {(() => {
                const journeySteps = getJourneySteps();
                if (journeySteps.length === 0) {
                  return (
                    <span className="custom-page-css text-xl font-light text-475467">Không xác định</span>
                  );
                }
                const lastIdx = journeySteps.length - 1;
                return journeySteps.map((step, idx) => {
                  const color = getStatusColor(step);
                  const isCurrent = idx === lastIdx;
                  return (
                    <React.Fragment key={step + idx}>
                      {idx > 0 && (
                        <div className="journey-line active" style={{ backgroundColor: getStatusColor(journeySteps[idx - 1]) }} />
                      )}
                      <div className="journey-step-wrapper">
                        <div
                          className={`journey-dot active ${isCurrent ? 'current' : ''}`}
                          style={{ backgroundColor: isCurrent ? '#fff' : color, borderColor: color, boxShadow: isCurrent ? `0 0 0 3px ${color}33` : 'none' }}
                        />
                        <span className="journey-label active" style={{ color }}>{step}</span>
                      </div>
                    </React.Fragment>
                  );
                });
              })()}
            </div>
          </div>
        </div>
      </div>
      <MegaTable
        stData={{ ...megaTableData, listData: detailData.list, loading }}
        stChange={(data) => {
          setMegaTableData((prev: any) => ({ ...prev, ...data }));
        }}
      />
    </>
  );
};
export default ContactHistory;
